import React, { useState, useEffect, useRef } from "react";
import { NavLink, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { FaTimes } from "react-icons/fa";
import Button from "web/components/Button";
import GetQuoteComponent from "web/components/GetQuote";
import YesNoModal from "web/components/YesNoModal";
import styled from "styled-components";
import headerLogo from "web/assets/images/NewHeaderLogo.png";
// import ContactUsIcon from "web/assets/images/contact-us-icon.png";
import ContactUsIcon from "web/assets/svg/ContactUsPhoneTxt";
import GuestUserAdvanceSearch from "web/components/GuestUserAdvanceSearch";
import MenuIcon from "web/assets/svg/MenuIcon";
import { UncontrolledPopover, PopoverBody } from "reactstrap";
import { FaChevronDown } from "react-icons/fa";

import "./publicNavbar.scss";
import { fetchLanguageContentNew } from "redux/actions/language";

// import { HashLink as NavLink } from "react-router-hash-link";

const PublicNavbar = ({ tabType }) => {
  let history = useHistory();
  const dispatch = useDispatch();
  const [modal, setModal] = useState(false);
  const toggleModal = () => setModal(!modal);
  let title = "";

  const [advanceModal, setAdvanceModal] = useState(false);
  const advanceModalToggleModal = () => setAdvanceModal(!advanceModal);

  const [click, setClick] = useState(false);
  const handleClick = () => setClick(!click);

  const currentLanguage = useSelector(
    (state) => state.language.currentLanguage
  );
  const languageContentNew = useSelector(
    (state) => state.language.languageContentNew
  );
  const [pageLanguageContents, setPageLanguageContents] = useState();

  useEffect(() => {
    if (languageContentNew?.Header_Page)
      setPageLanguageContents(languageContentNew.Header_Page);
    else dispatch(fetchLanguageContentNew(currentLanguage));
  }, [languageContentNew]);

  const closeMobileMenu = () => {
    history.push("/sign-in");
    setClick(false);
  };
  const signUp = () => {
    localStorage.setItem("guestUser", false);
    localStorage.setItem("postInventory", false);
    localStorage.setItem("memberShipType", "");
    history.push("/registration");
  };
  const contactUs = () => {
    history.push("/contact-us");
  };

  const [isMobile, setIsMobile] = useState(false);
  const [openSubMenu, setOpenSubMenu] = useState(null);

  useEffect(() => {
    // Check if the device is mobile based on window width
    const handleResize = () => {
      // setIsMobile(window.innerWidth <= 768); // Adjust the width as per your requirement
      setIsMobile(window.innerWidth <= 1023);
    };

    handleResize(); // Initial check
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleMouseEnter = (index) => {
    if (!isMobile) {
      setOpenSubMenu(index);
    }
  };

  const handleMouseLeave = () => {
    if (!isMobile) {
      setOpenSubMenu(null);
    }
  };

  const handleClick1 = (e, index) => {
    if (isMobile) {
      e.preventDefault(); // Prevents default navigation on click
      setOpenSubMenu(openSubMenu === index ? null : index);
    }
  };

  const navItems = [
    {
      to: "/pallet-buyer-solutions",
      text: "Buyer Solutions",
      content: (
        <ul>
          <li className="submenu">
            <NavLink to="/self-managed-services" className="drop-menu">
              Self Service
            </NavLink>
            <div className="on-mobile">
              <FaChevronDown />
            </div>
            <ul className="inner-sub-menu">
              <li>
                <NavLink to="/self-managed-services#what">What You Get</NavLink>
              </li>
              <li>
                <NavLink to="/self-managed-services#how">How it Works</NavLink>
              </li>
            </ul>
          </li>
          <li className="submenu">
            <NavLink to="/managed-services" className="drop-menu">
              Managed Services
            </NavLink>
            <div className="on-mobile">
              <FaChevronDown />
            </div>
            <ul className="inner-sub-menu">
              <li>
                <NavLink to="/managed-services#what">What You Get</NavLink>
              </li>
              <li>
                <NavLink to="/managed-services#our">Our Specialties</NavLink>
              </li>
            </ul>
          </li>
          <li className="submenu">
            <NavLink to="/customized-pallet-solutions" className="drop-menu">
              Customized Services
            </NavLink>
            <div className="on-mobile">
              <FaChevronDown />
            </div>
            <ul className="inner-sub-menu">
              <li>
                <NavLink to="/customized-pallet-solutions#what">What You Get</NavLink>
              </li>
              <li>
                <NavLink to="/customized-pallet-solutions#our">
                  Our Specialties
                </NavLink>
              </li>
            </ul>
          </li>
        </ul>
      ),
    },
    {
      to: "/pallet-supplier-and-broker-solutions",
      text: "Supplier Solutions",
      content: (
        <ul>
          <li className="submenu">
            <NavLink to="/pallet-supplier-and-broker-solutions#how">
              How it Works
            </NavLink>
          </li>
          <li className="submenu">
            <NavLink to="/pallet-supplier-and-broker-solutions#benefits">
              Benefits
            </NavLink>
          </li>
          <li className="submenu">
            <NavLink to="/pallet-supplier-and-broker-solutions#founder">
              The Founders Circle
            </NavLink>
          </li>
        </ul>
      ),
    },
    {
      to: "/about-us",
      text: "ABOUT",
      content: (
        <ul>
          <li className="submenu">
            <NavLink to="/about-us#faq">FAQs</NavLink>
          </li>
          <li className="submenu">
            <NavLink to="/about-us#membership">Membership</NavLink>
          </li>
          <li className="submenu">
            {/* <NavLink to="/about-us#newsroom">Newsroom</NavLink> */}
            <a
              href="https://newsroom.pallettrader.com/"
              target="_blank"
            >Newsroom</a>
          </li>
          {/* <li className="submenu">
            <NavLink to="/about-us#library">Spec Library</NavLink>
          </li> */}
        </ul>
      ),
      className: "about",
    },
  ];
  return (
    <>
      <nav className="navbar">
        <div className="nav-warpper">
          <div className="navbar-container public-navbar">
            <div className="menu-icon" onClick={handleClick}>
              {click ? <FaTimes /> : <MenuIcon />}
            </div>

            <NavLink to="/" className="navbar-logo" onClick={closeMobileMenu}>
              <img
                src={headerLogo}
                alt="logo"
                width="255px"
                height="47px"
                className="header-logo"
              />
            </NavLink>

            <ul className={click ? "nav-menu active" : "nav-menu"}>
              {/* <li className="nav-item">
                <NavLink
                  to="/who-its-for"
                  className="nav-link"
                  activeClassName="active"
                  onClick={closeMobileMenu}
                >
                  {pageLanguageContents?.Public_Header[1]?.TopSeller}
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  to="/how-it-works"
                  className="nav-link"
                  onClick={closeMobileMenu}
                >
                  {pageLanguageContents?.Public_Header[2]?.LatestAds}
                </NavLink>
              </li> */}
              {/* <li className="nav-item">
                <NavLink
                  to="/founders-circle"
                  onClick={closeMobileMenu}
                  className="nav-link"
                >
                  FOUNDERS CIRCLE
                </NavLink>
              </li> */}
              {/* dheerendra code  */}
              {navItems.map((item, index) => (
                <li
                  className="nav-item "
                  onMouseEnter={() => handleMouseEnter(index)}
                  onMouseLeave={handleMouseLeave}
                >
                  <NavLink
                    to={item.to}
                    className="nav-link drop-menu"
                    onClick={(e) => handleClick(e, index)}
                  >
                    {item.text}
                  </NavLink>

                  <div
                    className="on-mobile"
                    onClick={(e) => handleClick1(e, index)}
                  >
                    <FaChevronDown />
                  </div>

                  <div
                    className={`sub-menu-box ${openSubMenu === index ? "open" : ""
                      } ${item.className || ""}`}
                  >
                    {item.content}
                  </div>
                </li>
              ))}

              {/* <li className="nav-item">
                <a
                  className="nav-link"
                  href="https://newsroom.pallettrader.com/"
                  target="_blank"
                >
                  NEWSROOM
                </a>
              </li> */}
              {/* <li className="nav-item searchInventory mobile-menu">
                <div
                  onClick={() => {
                    setClick(false);
                  }}
                  className="nav-link"
                >
                  <GetQuoteComponent />
                </div>
              </li> */}
              <li className="nav-item searchInventory web-view-menu">
                <NavLink
                  to="/search-inventory"
                  onClick={closeMobileMenu}
                  className="nav-link"
                >
                  BUY PALLETS
                </NavLink>
              </li>
              <li className="nav-item mobile-menu">
                <NavLink
                  to="/contact-us"
                  className="nav-link"
                  activeClassName="active"
                  onClick={contactUs}
                >
                  CONTACT
                </NavLink>
              </li>
              <li className="nav-item mobile-menu">
                <NavLink
                  to="/registration"
                  className="nav-link"
                  onClick={signUp}
                >
                  SIGN UP
                </NavLink>
              </li>
            </ul>

            {/* <p className="subscription-promo-text">
              Use code <span style={{ color: "#61ae24" }}>WORLDSFIRST</span> for
              free subscription
            </p> */}
            {/* <p className="subscription-promo-text text-center">
              Use code <span style={{ color: "#0A5587" }}>X</span> for
              <br /> <span style={{ color: "#0A5587" }}>one year</span> free
              subscription
            </p> */}
            <ul className="right-menu">
            {/* <li className="nav-item searchInventory web-view-menu">
                <NavLink
                  to="/search-inventory"
                  onClick={closeMobileMenu}
                  className="nav-link"
                >
                  BUY PALLETS
                </NavLink>
              </li> */}
              <p className="subscription-promo-text text-center">
              Use code <span style={{ color: "#0A5587"}}>PALLET</span> for
              <br /> <span style={{ color: "#0A5587" }}>one year</span> free
              subscription
            </p>
              <li className="nav-item sign-up-btn web-view-menu">
                <NavLink
                  to="/contact-us"
                  className="nav-link contact-us-icon"
                  onClick={contactUs}
                >
                  <Button id="PopoverLegacy" type="button">
                    <ContactUsIcon />
                  </Button>
                  <UncontrolledPopover
                    placement="bottom"
                    target="PopoverLegacy"
                    trigger="legacy"
                  >
                    <PopoverBody>
                      <div style={{ display: "grid" }}>
                        <a href="tel:+1-877-777-7495">1-877-777-7495</a>
                        <a href="mailto:support@pallettrader.com">
                          support@pallettrader.com
                        </a>
                      </div>
                    </PopoverBody>
                  </UncontrolledPopover>
                </NavLink>
              </li>
              <li className="nav-item sign-up-btn web-view-menu">
                <NavLink to="" className="nav-link active" onClick={signUp}>
                  <Button className="sign-up-btn">SIGN UP</Button>
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  to="/sign-in"
                  className="nav-link"
                  onClick={closeMobileMenu}
                >
                  <Button>
                    {/* {pageLanguageContents?.Public_Header[4]?.SignIn} */}
                    <Button className="sign-up-btn">SIGN IN</Button>
                  </Button>
                </NavLink>
              </li>
            </ul>
          </div>
        </div>
      </nav>

      <GuestUserAdvanceSearch
        isOpen={advanceModal}
        toggle={advanceModalToggleModal}
        title=""
        onClickHander={(Obj) => { }}
        content=""
        link="/"
        pageType="PostInventory"
      />
      <YesNoModal
        isOpen={modal}
        toggle={toggleModal}
        title={title}
        content="Do you want to sell?"
        link="/Seller"
      />
    </>
  );
};

export default PublicNavbar;

const SearchWraper = styled.div`
  max-width: 1430px;
  margin: 0 auto;
  display: flex;
  align-items: flex-start;
  flex: 1;
  padding: 5px 0 5px 29px;
  gap: 24px;
  position: relative;
  z-index: 1;
  .custom-select__control {
    height: 35px;
    min-height: 35px;
    border-radius: 2px;
  }
  @media (max-width: 1250px) {
    padding: 5px 0;
  }
  @media (max-width: 718px) {
    display: grid;
    grid-gap: 10px;
    .topbar-hide-mobile {
      display: none;
    }
  }
`;

const SearchSection = styled.div`
  width: 100%;

  position: relative;
  z-index: 0;

  .type-ahead-search-input {
    > div input {
      height: 37px;
      border-radius: 5px;
      border: solid 1px #87cdf1;
    }
    .dropdown-menu .dropdown-item {
      padding: 10px 16px;
      font-size: 14px;
    }
    .seacrh-icon {
      margin: 0;
      height: 35px;
      position: absolute;
      cursor: pointer;
      right: 0;
    }
  }
  @media (max-width: 1250px) {
    max-width: 100%;
    min-width: 305px;
  }
  @media (max-width: 718px) {
    padding: 0;
  }
`;
const SearchContainer = styled.div`
  width: 100%;
  max-width: 1411px;
  padding: 0 85px;
  margin: 0 auto;
  display: flex;
  @media (max-width: 1250px) {
    padding: 0 15px;
  }
`;
const AdvanceSearchDiv = styled.div`
  border-radius: 5px;
  background: #61b01f;
  background: -moz-linear-gradient(top, #61b01f 0%, #27911b 100%);
  background: -webkit-linear-gradient(top, #61b01f 0%, #27911b 100%);
  background: linear-gradient(to bottom, #61b01f 0%, #27911b 100%);
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#61b01f', endColorstr='#27911b',GradientType=0 );
  color: #fff;
  font-size: 16px;
  text-decoration: none;
  min-width: 161px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 37px;
  cursor: pointer;
  font-family: "latobold";
  @media (max-width: 718px) {
    text-align: center;
  }
`;
const BlankSection = styled.div`
  min-width: 253px;
  padding: 0 20px;
  @media (max-width: 1250px) {
    display: none;
  }
`;
